import React from "react";

import CableSocketed from "_assets/icon-socket.svg";
import CableShort from "_assets/icon-cable-short.svg";
import CableMedium from "_assets/icon-cable-medium.svg";
import CableLong from "_assets/icon-cable-long.svg";
import { CableLength } from "_core/types/charger";
import { CableSetup } from "_core/types";

interface CableLengthIconProps {
  cableLength: CableLength;
}

interface CableSetupIconProps {
  cableSetup: CableSetup;
}

export const CableLengthIcon = ({ cableLength }: CableLengthIconProps) => {
  const alt = `Image of ${cableLength} cable length`;
  if (cableLength === "5m") {
    return <CableShort height={70} alt={alt} />;
  }
  if (cableLength === "5.5m") {
    return <CableShort height={70} alt={alt} />;
  }
  if (cableLength === "7.5m" || cableLength === "8.5m") {
    return <CableMedium height={70} alt={alt} />;
  }
  if (cableLength === "10m") {
    return <CableLong height={70} alt={alt} />;
  }
  return null;
};

export const CableSetupIcon = ({ cableSetup }: CableSetupIconProps) => {
  const alt = `Image of ${cableSetup} cable setup`;
  if (cableSetup === CableSetup.UNTETHERED) {
    return <CableSocketed height={70} alt={alt} />;
  }
  if (cableSetup === CableSetup.TETHERED) {
    return <CableLong height={70} alt={alt} />;
  }
  return null;
};
